// DS: C39B
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import readableFileSize from 'filesize';
import { Url } from '@wix/da-url';
import Button from '../Button';
import { ThemeOverride, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import PremiumAssetList from '../PremiumAssetList';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { formatDollars } from '../utils/formatting';
import s from './PcpPopover.scss';
export var PcpPopover = function (_a) {
    var _b, _c;
    var deviation = _a.deviation, _d = _a.deviation, deviationId = _d.deviationId, _e = _d.extended, _f = _e === void 0 ? {} : _e, pcp = _f.pcp, _g = _a.closeTooltip, closeTooltip = _g === void 0 ? function () { return null; } : _g, onDownload = _a.onDownload;
    var t = useTranslation().t;
    if (!pcp) {
        return null;
    }
    // TODO: this handles the case where the user has paid
    // but it'd never be used because of the branch in FreeAndPcpDownloadButton
    // that sends them to PcpDownloadLink instead. Remove that logic here
    var downloadUrl = (pcp.hasUserPurchased && pcp.url) || undefined;
    var typesIncluded = (pcp.assets || [])
        .map(function (asset) { return asset.type && asset.type.toLocaleUpperCase(); })
        .filter(function (type, index, array) { return type && array.indexOf(type) === index; })
        .join(' ');
    var checkoutUrl = ((_b = deviation.pcp) === null || _b === void 0 ? void 0 : _b.subproductId)
        ? Url.checkoutLink((_c = deviation.pcp) === null || _c === void 0 ? void 0 : _c.subproductId)
        : undefined;
    var handleClick = function (e) {
        if (downloadUrl) {
            onDownload && onDownload();
        }
        closeTooltip(e);
    };
    var titleWithPrice = t(pcp.downloadPrice && pcp.downloadPrice < 80
        ? 'pcp.buyForPoints'
        : 'pcp.buyForCurrency', {
        price: pcp.downloadPrice,
        dollars: formatDollars(pcp === null || pcp === void 0 ? void 0 : pcp.downloadDollarPrice),
    });
    return (React.createElement("div", { className: s['root'] },
        React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT },
            React.createElement("div", null,
                React.createElement("div", { className: s['title'] }, t('pcp.downloadDeviation')),
                React.createElement("div", { className: classnames(s['label'], s['pcp-label']) },
                    React.createElement("div", { className: s['pcp-header'] },
                        pcp.hasUserPurchased ? t('pcp.purchased') : titleWithPrice,
                        React.createElement("div", { className: s['pcp-header-details'] }, t('pcp.zipFileDetails', {
                            size: readableFileSize(pcp.zipFilesize || 0),
                            types: typesIncluded,
                        }))))),
            React.createElement("div", null,
                React.createElement(PremiumAssetList, { assets: pcp.assets }),
                React.createElement(Button, { view: "b18", className: s['download-button'], onClick: handleClick, href: downloadUrl || checkoutUrl, biData: {
                        evid: BiEventType.DOWNLOAD_NOW_CLICK,
                        deviationid: deviationId,
                    } }, downloadUrl
                    ? t('pcp.downloadNow')
                    : t('actionbar.download.mustPurchase'))))));
};
PcpPopover.displayName = 'PcpPopover';
export default PcpPopover;
//# sourceMappingURL=PcpPopover.js.map